<script setup lang="ts">

</script>

<template>
  <small class="hd-title-sm">Player Space</small>
  <router-view></router-view>
</template>

<style scoped>

</style>